/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllReferralCareAttributes200ResponseDataInner
 */
export interface FindAllReferralCareAttributes200ResponseDataInner {
    /**
     * 
     */
    id: string;
    /**
     * `discipline` holds Home Health required disciplines (SN/PT/OT/SLP/MSW/HHA) and applies only to Home Health facilities.
     */
    category: FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum;
    /**
     * 
     */
    label: string;
    /**
     * Short stable code / display abbreviation (e.g. `SN`) when the value has one.
     */
    code: string | null;
}


/**
 * @export
 */
export const FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum = {
    ClinicalCareNeed: 'clinical_care_need',
    Program: 'program',
    TypeOfCare: 'type_of_care',
    Discipline: 'discipline',
} as const;
export type FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum = typeof FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum[keyof typeof FindAllReferralCareAttributes200ResponseDataInnerCategoryEnum];


/**
 * Check if a given object implements the FindAllReferralCareAttributes200ResponseDataInner interface.
 */
export function instanceOfFindAllReferralCareAttributes200ResponseDataInner(value: object): value is FindAllReferralCareAttributes200ResponseDataInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function FindAllReferralCareAttributes200ResponseDataInnerFromJSON(json: any): FindAllReferralCareAttributes200ResponseDataInner {
    return FindAllReferralCareAttributes200ResponseDataInnerFromJSONTyped(json, false);
}

export function FindAllReferralCareAttributes200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllReferralCareAttributes200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'category': json['category'],
        'label': json['label'],
        'code': json['code'],
    };
}

export function FindAllReferralCareAttributes200ResponseDataInnerToJSON(json: any): FindAllReferralCareAttributes200ResponseDataInner {
    return FindAllReferralCareAttributes200ResponseDataInnerToJSONTyped(json, false);
}

export function FindAllReferralCareAttributes200ResponseDataInnerToJSONTyped(value?: FindAllReferralCareAttributes200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category': value['category'],
        'label': value['label'],
        'code': value['code'],
    };
}

